module.exports = __webpack_public_path__ + "img/nasi-ayam-geprek.5eb03817.jpg";